module.exports = __webpack_public_path__ + "static/img/vip_banner.135a6d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ad/vip_banner.png
// module id = Cxee
// module chunks = 1